import { z } from "zod";

// Reusable schema for building number validation across partner forms
export const buildingNumberSchema = (maxLength = 10) =>
	z
		.string()
		.refine((val) => val == null || val.trim().length <= maxLength, {
			message: `Building number is too long (max ${maxLength} characters)`,
		})
		.refine(
			(val) =>
				val === null ||
				val.trim().length === 0 ||
				/^[A-Za-z0-9\-/ ]+$/.test(val.trim()),
			{
				message: "Building number has invalid characters",
			},
		)
		.nullish();
